import { render, staticRenderFns } from "./PracticeCreate.vue?vue&type=template&id=a2458814&scoped=true&"
import script from "./PracticeCreate.vue?vue&type=script&lang=js&"
export * from "./PracticeCreate.vue?vue&type=script&lang=js&"
import style0 from "./PracticeCreate.vue?vue&type=style&index=0&id=a2458814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2458814",
  null
  
)

export default component.exports